export default "__VITE_ASSET__2GGoD2cB__"